import Vue from "vue";
import ConfigManager from "@/config/ConfigManager";
import BzbsCustom from "@/core/Custom/service/BzbsCustom.js";
import BzbsApi from "@/core/Http/BzbsApi.js";
import { map } from "rxjs/operators";

/**
 * @method requestOtp
 * @method confirmOtp
 * @method validateOtp
 * @method validateOtpChangeTel
 * @method validateOtpAndLogin
 */
export default {
    config: function() {
        return Vue.bzbsConfig;
    },
    /**
     * @param {String} contactNumber (required)
     * @param {String|Null} uuid (optional)
     * @param {string|Null} channel (oprional) update tel.: contact_number, other: authen
     */
    requestOtp: function(contactNumber, uuid, channel) {
        const params = {
            app_id: ConfigManager.getAppId(),
            contact_number: contactNumber,
            uuid: uuid,
            channel: channel // flow update tel use "contact_number"
        };

        const url = ConfigManager.getApiUrl() + "/auth/otp";
        return BzbsApi.connectBzbsGet(url, null, params).pipe(
            map(res => res.data)
        );
    },

    /**
     * @param {String} token
     * @param {String} contactNumber
     * @param {String} refcode
     * @param {String|Number} otp
     */
    confirmOtp: function(token, contactNumber, refcode, otp) {
        const params = {
            contact_number: contactNumber,
            otp: otp,
            refcode: refcode
        };

        const url = ConfigManager.getApiUrl() + "/auth/bzbs_authen";
        return BzbsApi.connectBzbsPost(url, token, params).pipe(
            map(res => res.data)
        );
    },

    /**
     * @param {string} contactNumber
     * @param {string} refcode
     * @param {number|string} otp
     * @param {string} channel
     * @returns {Observe}
     */
    validateOtp: function(token, contactNumber, refcode, otp, channel) {
        const params = {
            contact_number: contactNumber,
            otp: otp,
            refcode: refcode,
            channel: channel
        };

        const url = ConfigManager.getApiUrl() + "/auth/validate_otp";
        return BzbsApi.connectBzbsPost(url, token, params).pipe(
            map(res => res.data)
        );
    },

    /**
     * @param {string} contactNumber
     * @param {string} refcode
     * @param {number|string} otp
     * @param {string} channel
     * @returns {Observe}
     */
    validateOtpChangeTel: function(token, params) {
        const url = ConfigManager.getApiUrl() + "/auth/validate_otp";
        return BzbsApi.connectBzbsPost(url, token, params).pipe(
            map(res => res.data)
        );
    },

    /**
     * @param {string} contactNumber
     * @param {string} refcode
     * @param {number|string} otp
     * @returns {Observe}
     */
    validateNestleOtp: function(contactNumber, refcode, otp) {
        const params = {
            appId: ConfigManager.getAppId(),
            contactNumber: contactNumber,
            otp: otp,
            refcode: refcode
        };

        const url = ConfigManager.getApiModuleUrl() + "/sso/checkcontactnumber";
        console.log(url);
        return BzbsApi.connectBzbsPost(url, null, params).pipe(
            map(res => res.data)
        );
    },
    /**
     * @param {object} registerModel
     * @returns {Observe}
     */
    validateOtpAndLogin: function(registerModel) {
        const params = {
            id_token: registerModel.id_token,
            id_CardNo: registerModel.id_CardNo,
            contact_number: registerModel.contact_number,
            otp: registerModel.otp,
            refcode: registerModel.refcode,
            termAndCondition: "0"
        };

        const url = ConfigManager.getApiModuleUrl() + "/auth/login";
        return BzbsApi.connectBzbsPost(url, "", params).pipe(
            map(res => res.data)
        );
    },
    getBlob() {
        const url =
            "/nestle/nescafe_streetcafe/custom/nescafe_streetcafe_content.json";
        return new Promise((resolve, reject) => {
            BzbsCustom.apiGetCustom(url)
                .then(response => {
                    // console.log(response);
                    resolve(response);
                })
                .catch(error => {
                    console.log(error);
                    reject(error);
                });
        });
    },
    apiRequestDocument: function(strBzbsToken, finalData) {
        var params = {
            ...finalData
        };
        const url = ConfigManager.getApiUrl() + "/profile/me/export";
        return BzbsApi.connectBzbsPost(url, strBzbsToken, params);
    }
};
